import fetch from "auth/FetchInterceptor";

const ataDefinitionsTagsService = {};

ataDefinitionsTagsService.get = function (params = {}) {
	return fetch({
		url: "/v1/rest/ata-definitions-tags",
		method: "get",
		params,
	});
};

ataDefinitionsTagsService.post = function (data) {
	return fetch({
		url: "/v1/rest/ata-definitions-tags",
		method: "post",
		data: data,
	});
};

ataDefinitionsTagsService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/ata-definitions-tags/${id}`,
		method: "put",
		data: data,
	});
};

ataDefinitionsTagsService.getById = function (id) {
	return fetch({
		url: `/v1/rest/ata-definitions-tags/${id}`,
		method: "get",
	});
};

export default ataDefinitionsTagsService;
